/**
 * Scan dedup gate for continuous barcode scanning.
 *
 * @zxing/browser fires its decode callback every frame (~10fps) while a
 * barcode stays in view. Without a gate, one physical package becomes dozens of
 * stock-in notes. `shouldAccept` accepts a code once, then rejects the same
 * code until `cooldownMs` has passed since its last *accepted* sighting — so
 * one package records once, and the next package (even same SKU) records after
 * the cooldown. Rejected sightings do not move the anchor.
 */
export interface ScanDedup {
    shouldAccept: (code: string, nowMs: number) => boolean
}

export function createScanDedup(cooldownMs: number): ScanDedup {
    const lastAccepted = new Map<string, number>()

    return {
        shouldAccept(code, nowMs) {
            const prev = lastAccepted.get(code)
            if (prev !== undefined && nowMs - prev < cooldownMs) {
                return false
            }
            lastAccepted.set(code, nowMs)
            return true
        },
    }
}

/** Cooldown long enough that one held package records once, short enough to
 * scan the next identical-SKU package quickly. */
export const SCAN_DEDUP_COOLDOWN_MS = 1200
